import {
  Box,
  Button,
  CrudMode,
  DataArray,
  DataDisplay,
  Grid,
  GridBreak,
  pn,
  Stack,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import { DistrictEditResource, DistrictViewResource, FileCategory } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const FileCategoryPageBody = (props: {
  crudMode: CrudMode;
  fileCategory: FileCategory;
  setFileCategory: (value: FileCategory) => void;
  viewResource: DistrictViewResource;
  editResource: DistrictEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
    useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<FileCategory>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.fileCategory.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.fileCategory.name}
        onChange={(e) =>
          props.setFileCategory(
            produce(props.fileCategory, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {nameField()}
      </Grid>

      <GridBreak />
    </Grid>
  );
};
